// Eskom PARCC — React entry point. Mounts the application shell into #root.
// Shared stylesheets are loaded here: theme tokens/base first, then the
// reusable component classes lifted from the legacy monolith, and finally the
// Lumen theme — every one of its rules is `[data-ui='lumen']`-prefixed, so it
// layers over the Legacy look without touching it.
import './styles/theme.css';
import './styles/components.css';
import './styles/lumen.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
